export const breakpoints = {
  mobile: 320,
  tablet: 740,
  desktop: 980,
  wide: 1300,
}

export function resizeFancybox(instance, counter, nextDelay) {
  instance.update();
  counter++;
  setTimeout(resizeFancybox, nextDelay, instance, counter, counter > 5 ? 1000 : 200);
}



// WEBPACK FOOTER //
// ./scripts/utils.js